<div class="toolbar visible-gt-xsmall">
	<!-- item.isMousedown can be used to determine in blur event handler, that a specific item has just been clicked -->
	@for (item of $any(items()); track item) {
		<ng-container
			*ngTemplateOutlet="!item.dropdownItems ? singleButtonTemplate : buttonWithDropdown; context: { $implicit: item }"
		></ng-container>
	}
</div>

<ng-template #buttonWithDropdown let-item>
	<div class="button-with-dropdown">
		<ng-container *ngTemplateOutlet="singleButtonTemplate; context: { $implicit: item }"></ng-container>
		<ng-container *ngTemplateOutlet="dropdownButton; context: { $implicit: item }"></ng-container>
	</div>
</ng-template>

<ng-template #singleButtonTemplate let-item>
	@if (!item.disabled()) {
		<button
			class="button sm"
			title="{{ item.untranslated ? item.messageKey : (item.messageKey | translate) }}"
			[ngClass]="item.class"
			(click)="item.isMousedown = false; item.onClick()"
			(mousedown)="item.isMousedown = true"
		>
			@if (item.iconClass) {
				<i [ngClass]="item.iconClass"></i>
			}
			@if (!item.untranslated) {
				<span [translate]="item.messageKey"></span>
			}
			@if (item.untranslated) {
				<span>{{ item.messageKey }}</span>
			}
		</button>
	}
</ng-template>

<ng-template #dropdownButton let-item>
	@if (!item.disabled()) {
		<stages-menu
			menuId="add-dropdown"
			[noCollapse]="true"
			class="action"
			openTo="bottom dropdown"
			iconClasses="ico ico-chevron-down"
			[buttonNameKey]="item.dropdownMessageKey"
			[isToolbarDropdown]="true"
			[items]="item.dropdownItems"
			[context]="item"
		/>
	}
</ng-template>
